"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyFundDetailRequest = void 0;
var MyFundDetailRequest = /** @class */ (function () {
    function MyFundDetailRequest() {
    }
    return MyFundDetailRequest;
}());
exports.MyFundDetailRequest = MyFundDetailRequest;
;
//# sourceMappingURL=myFundDetail.request.js.map